import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Dialog from "material-ui/Dialog";
import Button from "react-bootstrap/lib/Button";
import TeamRegularisationTable from "../MyAttendance/ReactTable/TeamRegularisationTable";
import {hashHistory} from "react-router";
import * as actions from "../../../redux/actions/Attendance/attendanceActions";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";

const style = {
  height: 200,
  width: 300,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
};

class MyTeamRegularisation extends React.Component {

  constructor() {
    super();
    this.state = {value: 1, flag: true, actual: true, average: true, showAll: 0, open: true, empIds: [],
        uniqueEmpIds:[], selectedEmpId:null};
    this.handleSelect = this.handleSelect.bind(this);
    this.download_excel = this.download_excel.bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.applyRegularisation = this.applyRegularisation.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleSelect(selectedKey) {
    if (selectedKey != this.state.value)
      this.setState({value: selectedKey, flag: !this.state.flag});

  }

  onSelect(event, index, value) {
    this.setState({showAll: value});
  }

  toggleDetails() {
    this.setState({actual: !this.state.actual});
  }

  applyRegularisation(request) {
    this.props.dispatch(actions.applyTeamRegularisation(request));
  }

  download_excel() {

  }

  componentDidMount() {
    this.props.dispatch(actions.getTeamRegularisation());

    if(this.props.regState.length > 0) {
        for (let i = 0; i < this.props.regState.length ; i++) {
            this.setState({empIds: this.state.empIds.push(
                this.props.regState[i].applicantId + " - " + this.props.regState[i].applicantName)});
        }
        let removeDuplicates = Array.from(new Set(this.state.empIds));
        for (let i = 0; i < removeDuplicates.length ; i++) {
            this.setState({uniqueEmpIds: this.state.uniqueEmpIds.push(removeDuplicates[i])});
        }
    }

    this.setState({uniqueEmpIds : this.state.uniqueEmpIds.map((empId) =>
            <MenuItem value={empId} primaryText={empId}/>
        )});
  }

  refresh() {
      this.props.dispatch(actions.getTeamRegularisation());

      if(this.props.regState.length > 0) {
          for (let i = 0; i < this.props.regState.length ; i++) {
              this.setState({empIds: this.state.empIds.push(
                      this.props.regState[i].applicantId + " - " + this.props.regState[i].applicantName)});
          }
          let removeDuplicates = Array.from(new Set(this.state.empIds));
          for (let i = 0; i < removeDuplicates.length ; i++) {
              this.setState({uniqueEmpIds: this.state.uniqueEmpIds.push(removeDuplicates[i])});
          }
      }

      this.setState({uniqueEmpIds : this.state.uniqueEmpIds.map((empId) =>
              <MenuItem value={empId} primaryText={empId}/>
          )});

  }



  handleClose() {
    this.setState({open: false});
    hashHistory.push('1/attendance/team')
  };

  render() {
    const actions = [
      <Button


        backgroundColor={'#428BCA'}
        onTouchTap={()=> {

          hashHistory.push('1/attendance/team');
          this.props.changeBanner("Team Attendance");
        }
        }
      >Go Back</Button>
    ];

    const stylePaper = {
      height: "100%",
      width: "100%",
      paddingBottom: 5,
      marginTop: 10,
      textAlign: 'center',
      display: 'inline-block',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'rgb(92, 184, 92)'
    };


    const stylePaperInfo = {
      height: "100%",
      width: "60%",
      padding: 20,
      marginRight: '5%',

      marginLeft: '0',
      marginTop: '1%',
      textAlign: 'left',
      display: 'inline-block',
      borderStyle: 'solid',
      borderColor: '#616161'
    };
    let attendanceTeam = this.props.state[2];

    return (
      <div>

        {this.props.regState.length === 0 ? <div>
          <div>

            <Dialog
              title="Regularisation"
              contentStyle={{textAlign: 'center', height: '200px'}}
              actionsContainerStyle={{padding: '20px', marginRight: '50%', textAlign: 'center', paddingTop: 0}}
              actions={actions}
              modal={false}
              open={this.state.open}
              onRequestClose={this.handleClose}
            >
              You have no pending regularisation requests
              Thank You
            </Dialog>
          </div>
        </div> :

          <div>

            <div role="tabpanel" className="tab-pane" id="apply">
              <div className="row clearfix">
                  <div className="col-md-3 form-select-hrms">
                      <h3><b>Select Employee Name</b>  </h3>
                      <SelectField
                          name="employeeId"
                          style={{display: 'inline-block', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                          textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                          component={SelectField}
                          value={this.state.selectedEmpId}
                          onChange={(option, data, value)=> {
                              this.setState({selectedEmpId: value});
                          }}>
                          {this.state.uniqueEmpIds}
                          <MenuItem value={null} primaryText="ALL"/>
                      </SelectField>
                  </div>
                <div className="col-md-12" style={{marginLeft: '0px'}}>

                  {this.props.regState.map((node)=> {
                    if(this.state.selectedEmpId) {
                        if(node.applicantId + " - " + node.applicantName === this.state.selectedEmpId)
                        return <div style={stylePaper}><TeamRegularisationTable regularization={node}/></div>
                    } else {
                        return <div style={stylePaper}><TeamRegularisationTable regularization={node}/></div>
                    }
                  })}

                </div>
              </div>
            </div>
          </div>}
      </div>
    );
  }
}

MyTeamRegularisation.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state.attendance, regState: state.attendance[3].teamRegularisation
  };

}


export default connect(mapStateToProps)(MyTeamRegularisation);




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/MyTeamRegularisation.js
 **/